import { render } from "./FAQView.vue?vue&type=template&id=67b05faa"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=67b05faa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__